import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import axios from "axios";
import "./App.css";
import "./assets/styles/global.css";
import Login from "./pages/Account/Login";
//import Signup from "./pages/Account/Signup";
import { ConfigProvider, App as AntdApp } from "antd";
import theme from "./assets/styles/theme";
import styled from "styled-components";
import Header from "./component/Header";
import Footer from "./component/Footer";
import Home from "./pages/Home";
import KLA from "./pages/KLA";
import SLE from "./pages/SLE";
import MyPage from "./pages/Account/MyPage";
import SignupSelect from "./pages/Account/SignupSelect";
import IndividualSignup from "./pages/Account/IndividualSignup";
import OrganizationSignup from "./pages/Account/OrganizationSignup";
import Workbook from "./pages/workbook/Workbook";
import AdminPage from "./pages/Admin/AdminPage";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (user) => {
    setUser(user);
    localStorage.setItem("user", JSON.stringify(user));
  };

  /*
  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/logout`);
      setUser(null);
      localStorage.removeItem("user");
    } catch (error) {
      console.error("로그아웃 실패:", error);
    }
  };
  */

  return (
    <ConfigProvider theme={theme}>
      {/* antd v5: message/Modal/notification이 ConfigProvider 테마와 컨텍스트를
          제대로 받으려면 <App>으로 한 번 더 감싸야 함. 안 그러면 토스트가
          흰색 배경 + 흰 텍스트가 되거나 테마 미적용 상태로 표시됨. */}
      <AntdApp>
        <Router>
          <AppContent
            user={user}
            onLogout={() => setUser(null)}
            onLogin={handleLogin}
          />
        </Router>
      </AntdApp>
    </ConfigProvider>
  );
}

function AppContent({ user, onLogout, onLogin }) {
  const location = useLocation();
  const navigate = useNavigate(); // ✅ useNavigate는 여기서 호출해야 함

  const handleLogout = async () => {
    if (window.confirm("로그아웃 하시겠습니까?")) {
      try {
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/logout`);
        localStorage.removeItem("user");
        onLogout(); // 부모 컴포넌트의 상태 업데이트
        navigate("/"); // 로그아웃 후 메인 페이지로 이동
      } catch (error) {
        console.error("로그아웃 실패:", error);
      }
    }
  };

  //const hideHeaderRoutes = ["/login", "/signup", "/signup/individual", "/signup/organization"];
  //const showHeader = !hideHeaderRoutes.includes(location.pathname);

  const showHeader = !(
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/signup")
  );

  return (
    <MainContainer>
      {showHeader && <Header user={user} onLogout={handleLogout} />}
      <PageWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kla/*" element={<KLA user={user} />} />
          <Route path="/sle/*" element={<SLE user={user} />} />
          <Route path="/login" element={<Login onLogin={onLogin} />} />
          <Route path="/signup" element={<SignupSelect />} />
          <Route path="/signup/individual" element={<IndividualSignup />} />
          <Route path="/signup/organization" element={<OrganizationSignup />} />
          <Route path="/mypage" element={<MyPage user={user} />} />
          <Route path="/workbook" element={<Workbook />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute user={user} requireAdmin redirectPath="/login">
                <AdminPage user={user} />
              </ProtectedRoute>
            }
          />
        </Routes>
      </PageWrapper>
      {showHeader && <Footer />}
    </MainContainer>
  );
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
`;

const PageWrapper = styled.div`
  min-width: 320px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
`;

export default App;
